import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase/app';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CallRequestService {
  constructor(
    private afs: AngularFirestore,
    private auth: AuthService,
  ) {}

  createCallRequest(phone: string, name?: string, sourceUrl?: string): Promise<void> {
    if (!phone || !this.auth.uid) {
      return Promise.resolve();
    }

    const normalized = phone.replace(/[^\d+]/g, '');
    const request = {
      targetUid: this.auth.uid,
      callerPhone: normalized || phone,
      callerName: name || null,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      status: 'pending',
    };

    return this.afs.collection('callRequests').add(request).then(() => undefined);
  }
}
